<template>
  <LoadingWrapper :state="status">
    <p v-if="memberList.length === 0" class="text-body-large text-on-surface-variant">
      {{ $t('settings.organizationTeams.membersEmpty') }}
    </p>
    <div v-else class="flex flex-col gap-4">
      <ul class="flex flex-col gap-0.5">
        <li
          v-for="member in teamLeads"
          :key="member.id"
          class="bg-surface-container rounded-small first:rounded-t-large last:rounded-b-large flex flex-row items-center overflow-hidden"
        >
          <div class="flex min-w-0 grow flex-row items-center p-2">
            <BaseMemberAvatar :member="member" class="mr-4" />
            <div class="flex min-w-0 grow flex-col">
              <span class="text-body-large font-medium">{{ memberFullName(member) }}</span>
              <span
                v-if="memberSecondaryInformation(member)"
                class="text-body-medium text-on-surface-variant"
                >{{ memberSecondaryInformation(member) }}</span
              >
            </div>
          </div>
        </li>
      </ul>
      <ul class="flex flex-col gap-0.5">
        <li
          v-for="member in teamMembers"
          :key="member.id"
          class="bg-surface-container rounded-small first:rounded-t-large last:rounded-b-large flex flex-row items-center overflow-hidden"
        >
          <RouterLink
            :to="{ name: 'team-member', params: { teamId, memberId: member.id } }"
            class="group relative flex min-w-0 grow cursor-pointer flex-row items-center p-2"
          >
            <BaseMemberAvatar :member="member" class="mr-4" />
            <div class="flex min-w-0 grow flex-col">
              <span class="text-body-large font-medium">{{ memberFullName(member) }}</span>
              <span
                v-if="memberSecondaryInformation(member)"
                class="text-body-medium text-on-surface-variant"
                >{{ memberSecondaryInformation(member) }}</span
              >
            </div>
            <BaseIcon class="text-on-surface-variant shrink-0">chevron_right</BaseIcon>
            <BaseStateLayer />
          </RouterLink>
        </li>
      </ul>
    </div>
  </LoadingWrapper>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import LoadingWrapper from '@/core/components/loading/LoadingWrapper.vue'
  import BaseMemberAvatar from '@/core/components/base/avatar/BaseMemberAvatar.vue'
  import { memberFullName, memberSecondaryInformation } from '@/core/models/member/member-name'
  import { useTeamMembers } from '../composables/use-team-members'
  import BaseStateLayer from '@/core/components/base/state-layer/BaseStateLayer.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'

  const { members, status, teamId } = useTeamMembers()

  const memberList = computed(() => members.value ?? [])

  const teamLeads = computed(() => {
    return memberList.value.filter((member) => !member.pending && member.canLogin)
  })

  const teamMembers = computed(() => {
    return memberList.value.filter((member) => !member.pending && !member.canLogin)
  })
</script>
